import React, { useMemo, useState } from 'react';
import { Row, Col } from 'tea-component';
import CardCommon from '@/pages/opinion/components/CardCommon';
import TopicCard from '@op/pages/Performance/components/TopicKeyword/TopicCard';
import KeywordCard from '@op/pages/Performance/components/TopicKeyword/KeywordCard';
import useLanguage from '@/pages/opinion/hooks/useLanguage';

interface TopicKeywordSectionProps {
  filter: any;
  gameInfo?: any;
}

const TopicKeywordSection: React.FC<TopicKeywordSectionProps> = ({ filter, gameInfo }) => {
  const { formatMessage } = useLanguage();
  const [clickInfo, setClickInfo] = useState({
    dataIndex: null,
    seriesIndex: null,
    seriesName: null,
    name: null,
    except_others: null,
    except_topic: null,
    translationData: null,
  });

  const filterParams = useMemo(() => {
    return {
      ...filter,
      sentiment_type: 'total',
      channel_type: 'comments',
    };
  }, [filter]);

  const keywordFilter = useMemo(
    () => ({ ...filterParams, exclude_hashtag: true }),
    [filterParams],
  );

  return (
    <CardCommon title={formatMessage('Topic & Keywords')}>
      <Row className="performance-topic-keyword-card">
        <Col span={12} className="dbo-performance-topic-card">
          <TopicCard
            filter={filterParams}
            curFilter="total"
            handleClickInfo={(params: any) => setClickInfo(params)}
            {...(gameInfo ? { gameInfo } : {})}
          />
        </Col>
        <Col span={12} className="dbo-performance-keyword-card">
          <KeywordCard
            filter={keywordFilter}
            curFilter="total"
            clickInfo={clickInfo}
            statsDetailType="VersionAnalysis-keyword"
            hasKeywordDownPage={true}
            {...(gameInfo ? { gameInfo } : {})}
            dealwithTimeLineParams={(params: any) => ({
              ...params,
              statistics_field: 'overview',
            })}
          />
        </Col>
      </Row>
    </CardCommon>
  );
};

export default TopicKeywordSection;
